import { connect } from 'react-redux';
import {
  editBid,
  addBidNote,
  requestProposals,
  sendProposal,
  sendBid,
  removeBid,
  editMember,
  requestBidDetails,
  addHotelContact,
  sendHotelBidRequests,
  addBrandContact,
  HotelContactDelete,
  HotelContactUpdate,
  HotelBrandContactUpdate,
  HotelBrandContactDelete,
  requestBidsets
} from '../modules/tour';

import ProposalOverview from './ProposalOverview';

const mapDispatchToProps = {
  addBidNote,
  editBid,
  removeBid,
  requestProposals,
  sendBid,
  sendProposal,
  editMember,
  requestBidDetails,
  addHotelContact,
  sendHotelBidRequests,
  addBrandContact,
  HotelContactDelete,
  HotelContactUpdate,
  HotelBrandContactUpdate,
  HotelBrandContactDelete,
  requestBidsets
};

const mapStateToProps = state => ({
  proposals: state.tours.selectedTour.proposals,
  needFetch: state.tours.selectedTour.fetches.proposals.needFetch,
  isFetching: state.tours.selectedTour.fetches.proposals.isFetching,
  user: state.auth.profile.user,
  tour: state.tours.selectedTour.tour,
  bidbidsDetails: state.tours.bidbidsDetails
});
const ProposalOverviewContainer = connect(mapStateToProps, mapDispatchToProps)(ProposalOverview);
export default ProposalOverviewContainer;



// WEBPACK FOOTER //
// src/routes/tours/components/ProposalOverviewContainer.js